export default "__VITE_ASSET__B6MOB6DB__"